// 中医体质辨识（政府版）模块
// 仅处理 Physique/index.vue 渲染所需的字段：
//   - tizhi_content.is_qingxiang
//   - tizhi_content.physique
//   - tizhi_text_array
// 依赖：tizhi_content / tizhi_qingxiang_text_array 已在 pipeline.parseBase 完成 JSON.parse
//
// 注意：module_list / description_list 的合并、排序与 active 标记，
// 以及 tizhi_jingluo 的倾向体质合并，已下沉到各自消费方的 transform：
//   - Adjustment/transform.js
//   - Jingluo/transform.js

export default function transform(data) {
    if (!data) return;
    const tizhi_content = data.tizhi_content;
    if (!tizhi_content) return;

    const isFlowStep19 = Number(data.flow_step) === 19;

    // sys_company_id==84 且非 flow_step==19：把倾向体质并入主体质数组，并清掉 is_qingxiang 标记
    if (data.sys_company_id == 84 && !isFlowStep19) {
        tizhi_content.is_qingxiang = false;

        const physique_qingxiang = tizhi_content.physique_qingxiang;
        if (
            Array.isArray(physique_qingxiang)
            && physique_qingxiang.length > 0
            && JSON.stringify(tizhi_content.physique) !== JSON.stringify(physique_qingxiang)
        ) {
            tizhi_content.physique = tizhi_content.physique.concat(physique_qingxiang);
            data.tizhi_text_array = tizhi_content.physique;
        }
    }
}
